import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Rating } from '@fiverr-private/orca';
import { Stack } from '@fiverr-private/layout_components';
import { Text, Typography } from '@fiverr-private/typography';
import { numberFormat } from '@fiverr-private/localization';
import { ClientsRate } from '../../../shared/types';

const TRANSLATIONS_KEY = 'skill_page_perseus.ratings_banner';

interface Props extends ClientsRate {
    professionAliasPlural: string;
    isDefaultLocale: boolean;
}

export const RatingsBanner: React.FC<Props> = ({
    category,
    score,
    numberOfReviews,
    isDefaultLocale,
    professionAliasPlural,
}) => (
    <Stack
        direction={{ default: 'column', md: 'row' }}
        gap={{ default: '1', md: '3' }}
        borderRadius="lg"
        paddingY="5"
        paddingLeft={{ default: '4', md: '10' }}
        paddingRight="3"
        borderColor="grey_400"
        borderWidth="sm"
        marginTop={{ default: '8', sm: '8', md: '8', lg: '14', xl: '14' }}
        marginBottom={{ default: '8', sm: '8', md: '8', lg: '14', xl: '14' }}
    >
        <Text fontWeight="bold">
            {isDefaultLocale ? (
                <I18n k={`${TRANSLATIONS_KEY}.title`} params={{ professionAliasPlural }} />
            ) : (
                <I18n k={`${TRANSLATIONS_KEY}.title_localized`} params={{ category }} />
            )}
        </Text>
        <Rating score={score} color="black" scoreMaximumFractionDigits={1} />
        <Typography color="grey_1000">
            <I18n
                k={`${TRANSLATIONS_KEY}.review_based_on`}
                params={{
                    numberOfReviews: numberFormat({
                        value: numberOfReviews,
                        options: { fallbackValue: numberOfReviews },
                    }),
                }}
            />
        </Typography>
    </Stack>
);
